<template>
  <b-modal ref="modal" hide-footer title="Cập nhật sản phẩm con">
    <v-form ref="form" lazy-validation>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Mã vạch sản phẩm:" style="padding: 0px">
              <b-form-input
                size="sm"
                v-model="localBarcode"
                placeholder="Nhập mã vạch sản phẩm"
                @input="updateValue('barcode')"
              ></b-form-input>
            </b-form-group>

            <p class="mt-4 mb-4">
              <strong>Thuộc tính</strong>
            </p>

            <b-form-group label="Mã sản phẩm:">
              <b-form-input
                size="sm"
                v-model="localCode"
                placeholder="Nhập mã sản phẩm"
                @input="updateValue('code')"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Tên sản phẩm:">
              <b-form-input
                size="sm"
                v-model="localName"
                required
                placeholder="Nhập tên sản phẩm"
                @input="updateValue('name')"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <p class="mt-25 mb-4">
              <strong>Thông tin giao dịch</strong>
            </p>

            <b-form-group label="Giá nhập:">
              <b-form-input
                id="input-1"
                size="sm"
                v-model="localOriginalPrice"
                placeholder="Nhập giá nhập"
                type="text"
                class="text-right"
                v-mask="mask"
                @input="updateValue('originalPrice')"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Giá bán:" style="padding: 0px">
              <b-form-input
                size="sm"
                v-model="localSalePrice"
                placeholder="Nhập giá bán"
                type="text"
                class="text-right"
                v-mask="mask"
                @input="updateValue('salePrice')"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>

      <b-button
        style="fontweight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="$emit('save')"
        >Lưu</b-button
      >

      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="$emit('cancel')"
        >Hủy</b-button
      >
    </v-form>
  </b-modal>
</template>

<script>
import { currencyMask } from '@/utils/common';

export default {
  name: 'UpdateProductModal',
  props: {
    barcode: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    originalPrice: {
      type: [String, Number],
      default: 0,
    },
    salePrice: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      localBarcode: this.barcode,
      localCode: this.code,
      localName: this.name,
      localOriginalPrice: this.originalPrice,
      localSalePrice: this.salePrice,
      mask: currencyMask,
    };
  },
  watch: {
    barcode(val) {
      this.localBarcode = val;
    },
    code(val) {
      this.localCode = val;
    },
    name(val) {
      this.localName = val;
    },
    originalPrice(val) {
      this.localOriginalPrice = val;
    },
    salePrice(val) {
      this.localSalePrice = val;
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    updateValue(key) {
      switch (key) {
        case 'barcode':
          this.$emit('update:barcode', this.localBarcode);
          break;
        case 'code':
          this.$emit('update:code', this.localCode);
          break;
        case 'name':
          this.$emit('update:name', this.localName);
          break;
        case 'originalPrice':
          this.$emit('update:originalPrice', this.localOriginalPrice);
          break;
        case 'salePrice':
          this.$emit('update:salePrice', this.localSalePrice);
          break;
      }
    },
  },
};
</script>
